import { type ProjectCardV2DataWrapper_portfolioProject$key } from '#app/__generated__/relay/ProjectCardV2DataWrapper_portfolioProject.graphql.js';
import { type ProjectCardV2DataWrapper_userProfile$key } from '#app/__generated__/relay/ProjectCardV2DataWrapper_userProfile.graphql.js';
import { ProjectCardV2 } from './ProjectCardV2.js';
import { type ProjectCardV2DataWrapperProps } from './types.js';
import { graphql, useFragment } from '@contra/relay';

export const ProjectCardV2DataWrapper = ({
  canEdit,
  disabled,
  isDragging,
  isLastElement,
  openInNewWindow,
  portfolioProject,
  position,
  rolesSortFunction,
  sortableListeners,
  toolsSortFunction,
  userProfileRef,
}: ProjectCardV2DataWrapperProps) => {
  const portfolioProjectData =
    useFragment<ProjectCardV2DataWrapper_portfolioProject$key>(
      graphql`
        fragment ProjectCardV2DataWrapper_portfolioProject on PortfolioProject {
          id
          analyticsId
          slug
          title
          description
          llmSuggestionId
          publishedAt
          cover {
            ... on PortfolioProjectImageCover {
              __typename
              image {
                animated
                uid
              }
            }

            ... on PortfolioProjectTextCover {
              __typename
              style
            }
          }
          roles {
            edges {
              node {
                id
                name
              }
            }
          }
          tools {
            edges {
              node {
                id
                name
              }
            }
          }
        }
      `,
      portfolioProject,
    );

  const userProfileData = useFragment<ProjectCardV2DataWrapper_userProfile$key>(
    graphql`
      fragment ProjectCardV2DataWrapper_userProfile on UserProfile {
        id
        analyticsId
        visitorCanEdit
      }
    `,
    userProfileRef ?? null,
  );

  return (
    <ProjectCardV2
      canEdit={canEdit}
      disabled={disabled}
      isDragging={isDragging}
      isLastElement={isLastElement}
      openInNewWindow={openInNewWindow}
      portfolioProjectData={portfolioProjectData}
      position={position}
      rolesSortFunction={rolesSortFunction}
      sortableListeners={sortableListeners}
      toolsSortFunction={toolsSortFunction}
      userProfileData={userProfileData}
    />
  );
};
